import React from 'react'

const Spinner3Bounce = (props) => {
  return (
    props.isActive && (
      <div>
        <div className='sk-spinner sk-spinner-three-bounce'>
          <div className='sk-bounce1' />
          <div className='sk-bounce2' />
          <div className='sk-bounce3' />
        </div>
      </div>
    )
  )
}

export default Spinner3Bounce
